// import * as zxcvbn from 'zxcvbn'
import { Password } from '@/model/Password'
import { ERROR_CODES } from '@/model/ERROR_CODES'
import { distance } from 'fastest-levenshtein'

/**
 * This file contains all the password logic. Especially the configuration if a password is valid or not.
 *
 */

// eslint-disable-next-line
let zxcvbn: any = function () {
  return {
    score: 0,
  }
}
let dictionary: Array<string> = []
// the common build don't use the asynchrounous file loading (it's not working as dependency module)
if (process.env.VUE_APP_BUILD_TARGET === 'common') {
  import(
    /* webpackMode: "eager" */
    'zxcvbn'
  ).then((libray) => {
    zxcvbn = libray.default
  })
} else {
  import(/* webpackChunkName: "password-lib" */ 'zxcvbn')
    .then((libray) => {
      zxcvbn = libray.default
    })
    .catch(() => {
      // to not block the registration we return a allowed score as password score
      // TODO send via jslog - this should not happen
      zxcvbn = function () {
        return {
          score: 3,
        }
      }
      /* eslint no-console: ["error", { allow: ["error"] }] */
      console.error('An error occurred while loading the component')
    })
}
fetch('/gd/rest/userRegistration/dictionaries')
  .then((response) => {
    return response.json()
  })
  .then((res: GD_userRegistration.ForbiddenPasswords) => {
    dictionary = dictionary.concat(res.words)
  })
  .catch((err) => {
    /* eslint no-console: ["error", { allow: ["error"] }] */
    // console.error('loading words failed', err)
    // TODO JSLOG ??
  })

/**
 * returns score value for the given password object
 * @param password
 */
function overAllScore(password: Password) {
  let score = 0
  score += password.length ? 1 : 0
  score += password.specialChars || password.numbers ? 1 : 0
  score += password.scoreOk ? 1 : 0
  score += password.lowerUpperCase ? 1 : 0
  return score
}

function getPasswordErrorCode(password: Password): ERROR_CODES {
  if (!password.length) return ERROR_CODES.passInvalid
  else if (password.sameAsOldPassword) return ERROR_CODES.passwordEqualsPassword
  else if (password.sameAsUserName) return ERROR_CODES.passEqualsName
  else if (password.similarToUserName) return ERROR_CODES.passSimilarName
  else if (password.sameAsEmail) return ERROR_CODES.passwordEqualsEmail
  else if (!password.valid) return ERROR_CODES.passWeak
  return
}

function validatePassword({
  password,
  name,
  currentPassword,
  email,
}: {
  password: string
  currentPassword?: string
  name?: string
  email?: string
}): Password {
  const result = zxcvbn(password, dictionary.concat([name]))
  const pwd: Password = {
    value: password,
    valid: false,
    errorCode: undefined,
    length: password.length >= 10,
    // contain special characters first: all except letters OR (list of char which are regarded same as \w)
    specialChars: password.length > 0 && (!/^[\w]+$/.test(password) || /[,_]/.test(password)),
    numbers: /\d/.test(password),
    scoreOk: result.score > 2,
    similarToUserName: distance(name || 'asdsa', password) <= 4,
    lowerUpperCase: /(.*[a-z].*)(.*[A-Z].*)|(.*[A-Z].*)(.*[a-z].*)/.test(password),
    sameAsOldPassword: password.length > 0 && password === currentPassword,
    sameAsUserName: password.length > 0 && name === password,
    sameAsEmail: password.length > 0 && password === email,
    score: result.score,
  }
  // eslint-disable-next-line
  pwd.scoreOk = pwd.similarToUserName ? false : pwd.scoreOk
  pwd.valid = overAllScore(pwd) === 4 && !pwd.sameAsOldPassword && !pwd.sameAsUserName && !pwd.sameAsEmail
  pwd.errorCode = getPasswordErrorCode(pwd)
  return pwd
}

export { validatePassword, overAllScore }
